import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect, lazy, Suspense } from "react";
import { SettingsProvider } from "@/context/SettingsContext";
import { HelmetProvider } from 'react-helmet-async';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Eagerly load critical pages
import HomePage from "@/pages/v2/HomePage.v2";
import CastlesPage from "@/pages/CastlesPage";

// Lazy load non-critical pages
const CastleDetailPage = lazy(() => import("@/pages/CastleDetailPage"));
const BookingPage = lazy(() => import("@/pages/BookingPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const SafetyPage = lazy(() => import("@/pages/SafetyPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const AdminLoginPage = lazy(() => import("@/pages/admin/AdminLoginPage"));
const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));

// Simple loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#47B5E6] to-[#7DD889]">
    <div className="text-white text-lg font-semibold">Loading...</div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <SettingsProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/castles" element={<CastlesPage />} />
                <Route path="/castles/:id" element={<CastleDetailPage />} />
                <Route path="/booking" element={<BookingPage />} />
                <Route path="/booking/:castleId" element={<BookingPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/safety" element={<SafetyPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin/*" element={<AdminDashboard />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </SettingsProvider>
      </div>
    </HelmetProvider>
  );
}

export default App;
